import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DatePipe, registerLocaleData } from '@angular/common';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { UserComponent } from './user/user.component';
import { ConstructionSiteComponent } from './construction-site/construction-site.component';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { CalendarComponent } from './calendar/calendar.component';
import localeDe from '@angular/common/locales/de';
import { HoursOverviewComponent } from './hours-overview/hours-overview.component';
import { SettingsComponent } from './settings/settings.component';
import {
  AppErrorHandler,
  AuthenticationInterceptor,
  SharedModule,
} from 'projects/shared/src/public-api';
import { Injectable } from '@angular/core';
import { CalendarEventTitleFormatter, CalendarEvent } from 'angular-calendar';
import { AbsenceOverviewComponent } from './absence-overview/absence-overview.component';
import { ConstructionDayReportOverviewComponent } from './construction-day-report-overview/construction-day-report-overview.component';
import { HomeComponent } from './home/home.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { MainViewComponent } from './main-view/main-view.component';
import { MachineryOverviewComponent } from './machinery-overview/machinery-overview.component';
import { FilesComponent } from './files/files.component';

@Injectable()
class CustomEventTitleFormatter extends CalendarEventTitleFormatter {
  override monthTooltip(event: CalendarEvent, title: string): string {
    return null;
  }
  override dayTooltip(event: CalendarEvent, title: string): string {
    return null;
  }
  override weekTooltip(event: CalendarEvent, title: string): string {
    return null;
  }
}

registerLocaleData(localeDe);
@NgModule({
  declarations: [
    AppComponent,
    UserComponent,
    ConstructionSiteComponent,
    HoursOverviewComponent,
    CalendarComponent,
    ConstructionDayReportOverviewComponent,
    HomeComponent,
    SettingsComponent,
    AbsenceOverviewComponent,
    SidebarComponent,
    MainViewComponent,
    MachineryOverviewComponent,
    FilesComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    BrowserModule,
    SharedModule,
    IonicModule.forRoot(),
    AppRoutingModule,

    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
  ],
  providers: [
    { provide: ErrorHandler, useClass: AppErrorHandler },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticationInterceptor,
      multi: true,
    },
    DatePipe,
    { provide: LOCALE_ID, useValue: 'de-DE' },
    {
      provide: CalendarEventTitleFormatter,
      useClass: CustomEventTitleFormatter,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
